// modules/LotButton.js
import React            from 'react';
import { Link }         from 'react-router'
import Arrow            from '../../images/arrow';
import renderHTML       from 'react-render-html';

class LotButton extends React.Component {
	constructor(props) {
		super(props);
		this.state = {active: false};

		this.scrollLotContainer    = this.scrollLotContainer.bind(this);
		this.showBHoverEvent       = this.showBHoverEvent.bind(this);
		this.hideBHoverEvent       = this.hideBHoverEvent.bind(this);
		this.showBHoverAreas       = this.showBHoverAreas.bind(this);
		this.hideBHoverAreas       = this.hideBHoverAreas.bind(this);

		this.props.messenger.subscribe("a_"+this.props.id, this.showBHoverEvent);
		this.props.messenger.subscribe("c_"+this.props.id, this.hideBHoverEvent);
		this.props.messenger.subscribe("s_"+this.props.id, this.scrollLotContainer);
	}

	componentWillUnmount() {
		this.props.messenger.remove("a_"+this.props.id);
		this.props.messenger.remove("c_"+this.props.id);
		this.props.messenger.remove("s_"+this.props.id);
	}

	scrollLotContainer() {
		var scroll = this.props.index * 45;
		document.getElementById('LotsContainer').scrollTop = scroll;
	}

	showBHoverEvent() {
		this.setState({active:true});
	}

	hideBHoverEvent() {
		this.setState({active:false});
	}

	showBHoverAreas(move) {
		this.props.messenger.publish("a_"+this.props.id, {move:move});
	}

	hideBHoverAreas() {
		this.props.messenger.publish("c_"+this.props.id, {});
	}
	render() {
		var divclasses = this.props.buttonclass;
		if (this.state.active) {
			divclasses += " active";
		}
		return (
			<Link to={this.props.buttonlink}>
				<div className={divclasses} id={this.props.id} onMouseEnter={this.showBHoverAreas} onMouseLeave={this.hideBHoverAreas}>
					<div>{renderHTML(this.props.children)}</div>
					<Arrow/>
				</div>
			</Link>
		);
	}
}

export default LotButton;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/elements/LotButton.js
 **/